import cn from 'classnames';
import { forwardRef } from 'react';
import { InputProps, Field, FieldDescription, FieldError, FieldLabel } from '@/shared/ui/core';
import styles from './input.module.scss';


export const Input = forwardRef<HTMLInputElement, InputProps>(function Input ({
    className,
    inputClassName,
    label,
    description,
    error,
    state = 'default',
    leftSlot,
    rightSlot,
    disabled,
    ...props
}, ref) {
    const isError       = state === 'error' || Boolean(error);
    const isSuccess     = state === 'success';
    const isWarning     = state === 'warning';
    const isDefault     = state === 'default';
    const textClassname = cn({
        [styles.default]    : isDefault,
        [styles.destructive]: isError,
        [styles.success]    : isSuccess,
        [styles.warning]    : isWarning,
        [styles.disabled]   : disabled,
    });

    return (
        <Field className={ className }>
            <div className={ cn(styles.root, textClassname) }>
                {
                    label &&
                    <FieldLabel
                        className={ textClassname }
                        required={ props.required }
                    >
                        { label }
                    </FieldLabel>
                }

                <div className={ styles.wrapper }>
                    {
                        leftSlot &&
                        <span className={ cn(styles.left_slot, textClassname) }>
                            { leftSlot }
                        </span>
                    }

                    <input
                        ref={ ref }
                        disabled={ disabled }
                        className={ cn(styles.input, textClassname, inputClassName) }
                        { ...props }
                    />

                    {
                        rightSlot &&
                        <span
                            className={ cn(styles.right_slot, textClassname) }
                        >
                            { rightSlot }
                        </span>
                    }
                </div>
            </div>

            {
                isError &&
                error &&
                <FieldError className={ textClassname }>
                    { error }
                </FieldError>
            }

            {
                !isError &&
                description &&
                <FieldDescription className={ textClassname }>
                    { description }
                </FieldDescription>
            }
        </Field>
    );
});
